export enum Units {
  DOLLAR_PER_CWT = '$/cwt',
  DOLLAR_PER_LB = '$/lb',
  DOLLAR_PER_HEAD = '$/head',
  DOLLAR = '$',
  PERCENT = '%',
  NONE = ''
}
